import { render, staticRenderFns } from "./DeliveryNavbar.vue?vue&type=template&id=556bc50c&scoped=true&"
import script from "./DeliveryNavbar.vue?vue&type=script&lang=js&"
export * from "./DeliveryNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNavbar.vue?vue&type=style&index=0&id=556bc50c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556bc50c",
  null
  
)

export default component.exports